import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { cities } from "../../data/cities";
import './menu.css'
import connect from "react-redux/es/connect/connect";
import { getCityById } from "../../ducks/cities";
import { toggleMenu } from "../../ducks/menu";
import { sendEvent } from "../../helpers/analytics";

class Menu extends Component {
  state = {
    animated: false
  }

  componentDidMount() {
    const self = this
    window.onscroll = function() {
      const d = document.documentElement;
      const offset = d.scrollTop + window.innerHeight;
      const height = d.offsetHeight;

      if(window.pageYOffset === 0) {
        self.addAnimatedClass()
      }

      if (offset === height) {
        self.addAnimatedClass()
      }
    };
  }

  addAnimatedClass = () => {
    this.setState({animated: true})
    setTimeout(() => {
      this.setState({animated: false})
    }, 2000)
  }

  componentWillUnmount() {
    window.onscroll = null;
  }

  menuClickHandler = () => {
    this.props.toggleMenu()
    sendEvent('menu', 'click', 'where-to')
  }

  menuItemClickHandler = (city) => {
    this.props.toggleMenu()
    sendEvent('menu', 'click', `where-${city}`)
  }

  render () {
    const { isOpen } = this.props.menu
    const { isArticle, location } = this.props
    const { animated } = this.state
    return (
      <div className={`menu ${isArticle ? 'menu--article' : ''} `}>
        {location === '/' ?
          null
          :
          <div className={`menu__button ${animated && isArticle ? 'animated' : ''}`} onClick={this.menuClickHandler}>
            {isArticle ?
              <span>
              <img src="/images/plane.png" alt=""/>
            </span>
              :
              <span>{isOpen ? <span> На<br />главную</span> : <span> Куда<br />полететь</span>}</span>
            }

          </div>
        }


        <div className="menu__list" style={{display: isOpen ? 'block' : 'none'}}>
          <div className="container">
            <div className="menu__col">
                {cities.map((city, index) => <div key={city.title}><NavLink to={`/article/${index}`} activeClassName="active">
                  <span onClick={() => this.menuItemClickHandler(city.title)}>{city.title}</span>
                </NavLink></div>)}
                <div className="fake-item" />
            </div>
          </div>
        </div>
      </div>
    )
  }
}


export default connect(
  (state) => {
    return {
      // city: state.city,
      menu: state.menu
    }
  },
  { getCityById, toggleMenu }
)(Menu)



// WEBPACK FOOTER //
// ./src/components/menu/menu.js